<template>
  <!-- this.$store.state.excel == false면 안보이게 -->
  <CButton
    v-if="this.$store.state.excel"
    type="button"
    :color="this.btnClass"
    @click="this.download()"
    >{{ this.btnNm }}</CButton
  >
</template>

<script>
import axios from '@/api/index.js'

export default {
  name: 'gridExcelDownloadBtn',
  props: {
    btnClass: { default: 'dark', type: String }, // 버튼 text
    btnNm: { default: '엑셀다운로드', type: String }, // 버튼 text
    downUrl: { default: '', type: String }, // 엑셀 다운로드 method url
    sheetName: { default: '', type: String }, // 다운받는 엑셀 sheet명
    excelFileNm: { default: '목록', type: String }, // 다운받는 엑셀 파일명
    excelHeader: {
      default: () => {
        return []
      },
      type: Array,
    }, // 엑셀 column
    delExcelHeader: { default: '', type: String }, // 전달 받은 엑셀 column중 제외할 컬럼(ex -> "mbrSn, prtnSn, ..., menuSn")
    formData: {
      default: () => {
        return {}
      },
      type: Object,
    }, // 엑셀내용 조회 data
  },
  data() {
    return {}
  },
  methods: {
    setDownParams: function () {
      const formData = new FormData()

      Object.entries(this.formData).forEach(([key, value]) => {
        if (value != null && this.delExcelHeader.indexOf(key) == -1) {
          if (this.$filters.nvl(key, '') == 'page') {
            formData.append(key, 1)
          } else {
            formData.append(key, value)
          }
        }
      })

      // sheet명이 있으면 전달(back단에서 sheetName 받는 파라미터 명은 sheetName으로 고정 필요)
      if (this.$filters.nvl(this.sheetName, '') != '') {
        formData.append('sheetName', this.sheetName)
      }

      formData.append('columnDefs', JSON.stringify(this.excelHeader))

      return formData
    },
    download: function () {
      let params = {
        method: 'post',
        url: this.downUrl,
        header: { 'Content-Type': 'application/json' },
        responseType: 'blob',
        data: this.setDownParams(),
      }

      axios(params)
        .then((response) => {
          const url = window.URL.createObjectURL(
            new Blob([response.data], {
              type: response.headers['content-type'],
            }),
          )
          const link = document.createElement('a')
          link.href = url

          link.setAttribute(
            'download',
            this.excelFileNm + '_' + this.$filters.getStrDate(new Date()) + '.xlsx',
          )
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
        })
        .catch((error) => console.log(error))
    },
  },
  created() {},
}
</script>
